export default {
    LOAD_CONTENT_TYPES (state, contentTypes) {
        state.items = contentTypes
    },
}